
export const Categories = {
    Site: "Site",
    MyTeam: "My Team",
};
